// src/components/admin/user/UserApi.ts

import axios from 'axios';
import { API_ENDPOINTS } from '../../../apiConfig';
export interface User {
  id: string;
  firstName: string;
  lastName?: string;
  email: string;
  mobileNo?: string;
  hashedPassword?: string;
  designation?: string;
  tenantId?: string;
  tenantName?:string;
  profileImage?:string;
  
  username?: string;
  isActive?: boolean;
  comment?: string;
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
}

export interface PaginatedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number; // current page
  size: number;
}

const API_BASE = `${API_ENDPOINTS.platform}/users`;
const USER_PERMISSIONS_API = `${API_ENDPOINTS.platform}/user-module-permissions`;

export interface DateRange {
  from?: string;
  to?: string;
}

export interface UserFilterRequest {
  email?: string;
  mobileNo?: string;
  designation?: string;
  isActive?: string;
  dateRange?: DateRange;
  pagination: {
    page: number;
    size: number;
  };
  sort: {
    field: string;
    direction: 'asc' | 'desc';
  };
}

export const fetchUsers = () => {
  return axios.get<User[]>(API_BASE);
};

export const fetchUserById = (id: string) => {
  return axios.get<User>(`${API_BASE}/${id}`);
};

export const createUser = (user: Partial<User>) => {
  return axios.post<User>(API_BASE, user);
};

export const updateUser = (id: string, user: Partial<User>) => {
  return axios.put<User>(`${API_BASE}/${id}`, user);
};

export const deleteUser = (id: string) => {
  return axios.delete(`${API_BASE}/${id}`);
};

export const fetchFilteredUsers = (filter: UserFilterRequest) => {
  return axios.post<PaginatedResponse<User>>(`${API_BASE}/filter`, filter);
};

export interface UserPermissionDTO {
  moduleId: string;
  moduleName: string;
  moduleDescription: string;
  canCreate: boolean;
  canView: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canReport: boolean;
}

export interface UserSearchRequest {
  keyword?: string;
  tenantId: string; // UUID as string
  tenantName?: string;
}
/**
 * Fetch permissions for a specific user by userId.
 * @param userId - UUID of the user
 */
export const fetchUserPermissions = async (userId: string) => {
  return axios.get<UserPermissionDTO[]>(`${USER_PERMISSIONS_API}/user/${userId}`);
}; 

export const searchUsersWithNames = async (userSearchRequest: UserSearchRequest) => {
  if ((userSearchRequest.keyword ?? '').length < 2) return [];
  const response = await axios.post<User[]>(`${API_BASE}/user-name-search`, userSearchRequest);
  return response.data;
};